import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {CommonWrapper, CommonContent} from './LightHomePage.style';

export const WrapperStrip = styled.section`
  background: ${p => `url(${p.url}=s1000) no-repeat fixed center center`};
  background-size: cover;
  color: ${p => p.theme.primaryColor};
  position: relative;
  ${media.medium`
    background: ${p => `url(${p.url}=s800) no-repeat fixed center center`};
  `};
  ${media.small`
    background-attachment: initial;
  `};
`;

export const Wrapper = CommonWrapper.extend`
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  color: ${p => p.theme.textColor};
  background-color: ${p => p.theme.primaryColor};
  ${media.small`
    overflow: hidden;
  `};
`;

export const Left = styled.div`
  display: flex;
  padding: 3rem 2rem;
  width: 60%;
  min-width: 60%;
  max-width: 60%;
  overflow: hidden;
  ${media.small`
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 3rem 0;
  `};
`;

export const Right = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem 0;
  text-align: ${p => p.alignLeft ? 'left' : 'center'};
  width: ${p => p.expand ? '100%' : 'auto'};
`;

export const Content = CommonContent.extend`
  flex-direction: row;
  align-items: flex-start;
  ${media.small`
    flex-direction: column;
  `};
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/PicText.style.js